<template>
    <div class="row">
        <div class="col-md-12 col-xl-12">
            <el-skeleton style="width: 100%; height: 100%" :loading="loading" animated>
                <!--eslint-disable-->
                <template slot="template">
                    <el-skeleton-item variant="div" style="width: 100%; height: 48px; margin-bottom: 1.5rem" />
                    <el-skeleton-item variant="div" style="width: 100%; height: 48px; margin-bottom: 1.5rem" />
                    <el-skeleton-item variant="div" style="width: 100%; height: 48px; margin-bottom: 1.5rem" />
                    <el-skeleton-item variant="div" style="width: 100%; height: 48px; margin-bottom: 1.5rem" />
                    <el-skeleton-item variant="div" style="width: 100%; height: 48px; margin-bottom: 1.5rem" />
                    <el-skeleton-item variant="div" style="width: 100%; height: 48px; margin-bottom: 1.5rem" />
                </template>
                <template>
                    <mechanism-panel v-if="!loading" v-for="(item, index) in data" :data="item" :key="index" :text="item.category"></mechanism-panel>
                </template>
            </el-skeleton>
        </div>
    </div>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
    import {INFORMATION_MECHANISM} from "@/core/services/store/service.module";
    import MechanismPanel from "@/views/pages/information/chinh-sach-panel";
    export default {
        name: "chinh-sach",
        components: {
            MechanismPanel
        },
        data() {
            return {
                data: [],
                loading: false
            }
        },
        methods:{
            queryServer() {
                this.loading = true;
                this.$store.dispatch(INFORMATION_MECHANISM)
                    .then((response) => {
                        if (response.status === 422) {
                            this.loading = false;
                            this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                        } else {
                            this.loading = false;
                            this.data = response.data;
                        }
                    })
            }
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Thông tin", icon: 'far fa-info-square'},
                {title: "Chính sách nhân sự", icon: 'far fa-info-square'}
            ]);
            this.queryServer();
        }
    }
</script>
